import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useColorMode } from './ColorModeContext';
import { AuthProvider } from "./components/AuthContext";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import JobBankSignup from "./components/JobBankSignup";
import Signdown from "./components/Signdown";
import JobBankSigndown from "./components/JobBankSigndown";
import Dashboard from "./components/ResumeRevisor";
import About from "./components/About";
import Tokens from "./components/Tokens";
import Careers from "./components/Careers";
import Menu from "./components/Menu";
import Contactus from "./components/Contactus";
import ConversationPractice from "./components/Conversationpractice";
import ProtectedRoute from "./utils/ProtectedRoute";
import PasswordReset from "./components/PasswordReset";
import JobBankPasswordReset from "./components/JobBankPasswordReset";
import PaymentSuccessful from "./components/PaymentSuccessful";
import PageExpired from "./components/PageExpired";
import PaymentNotSuccessful from "./components/PaymentNotSuccessful";
import Purchase from "./components/Purchase";
import TermsofService from "./components/TermsofService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";
import InterviewPractice from "./components/InterviewPractice";
import Admin from "./components/Admin";
import { VoiceBotStateProvider } from "./components/VoiceBotStateContext";
import { ColorModeProvider } from "./ColorModeContext";
import axios from "axios";
import { TokenProvider } from "./components/tokenContext";
import HexagonBackground from "./components/HexagonBackground";
import { shouldHideAppHexagon } from "./voicebotSession/voiceBotJourney";
import AccountDeleted from "./components/AccountDeleted";
import "./App.css";
import logosmall from "./components/logosmall.PNG";
import CookieConsent from "./components/CookieConsentComponent";
import CookiePolicy from "./components/CookiePolicy";
import { isMobile } from 'react-device-detect';
import { TimerProvider } from './components/TimerProvider';
import PurchaseHistory from './components/PurchaseHistory';
import VisemeProvider from './components/VisemeProvider';
import AdminOffersConsole from "./components/AdminOffersConsole";
import Security from "./components/Security"; 
import usePageTracking from "./components/usePageTracking";
import PodcastTools from './components/PodCastTools';
import JobBank from './components/JobBank';
import CandidateProfile from './components/CandidateProfile';
import EmployerDashboard from './components/EmployerDashboard';
import JobBankLandingPage from './components/JobBankLandingPage';
import CareerCoachPortal from './components/CareerCoachPortal';
import HiringEventsPortal from './components/HiringEventsPortal';
import JobBankAbout from "./components/JobBankAbout";
import JobBankContact from "./components/JobBankContact";
import JobBankHelp from "./components/JobBankHelp";
import JobBankLogin from "./components/JobBankLogin";
import UrlShortenerAdmin from "./components/UrlShortenerAdmin";
import AccessRequest from "./components/accessRequest";
import AccessRequests from "./components/accessRequests";
import JobCarveOutPortal from './components/JobCarveOutPortal';
import PublicCareerCoachDirectory from "./components/PublicCareerCoachDirectory";
import PublicEmployerDirectory from "./components/PublicEmployerDirectory";
import PublicCandidateDirectory from "./components/PublicCandidateDirectory";
import Spinner from "./components/Spinner";

const VB = lazy(() => import("./components/VB"));
const VBM = lazy(() => import("./components/VBM"));

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

function App() {  
  return (
    <AuthProvider>
      <ColorModeProvider>
        <ActualAppContent />
      </ColorModeProvider>
    </AuthProvider>
  );
}

function PageTrackingWrapper({ children }) {
  usePageTracking();
  return children;
}

function AppHexagonLayer() {
  const location = useLocation();
  if (shouldHideAppHexagon(location.pathname)) return null;
  return (
    <div className="HexagonBackGround">
      <HexagonBackground />
    </div>
  );
}

const ActualAppContent = () => {
  const { colorMode } = useColorMode();
  const [signupEnabled, setSignupEnabled] = useState(false); //<------------------------ENABLE SIGNUP!
  useEffect(() => {
    const root = document.documentElement; // Access the root element
    const newTextColor = colorMode <= 9 ? 'var(--text-color-mode-1)' : 'var(--text-color-mode-2)';
    root.style.setProperty('--text-color', newTextColor);
    console.log(colorMode);
    console.log(newTextColor);
  }, [colorMode]);

  useEffect(() => {
    async function checkSignup() {
      try {
        const res = await axios.get("https://fluency.ispeakwell.ca/api/signup-status");
        setSignupEnabled(res.data.allowed);
      } catch (e) {
        console.error("Failed to fetch signup status:", e);
        setSignupEnabled(false); // fail closed
      }
    }
    checkSignup();
  }, []);

  return (
      <VoiceBotStateProvider>
          <Router>
            <PageTrackingWrapper>
              <AppHexagonLayer />
              <div className="content-container">
                <div className="logoContainer">
                  <img
                    className="Logo"
                    src={logosmall}
                    alt="iSpeakWell logo"
                    onClick={() => window.location.href = "/"}
                  ></img>
                </div>
                <div>
                  <CookieConsent
                    location="bottom"
                    buttonText="I understand"
                    cookieName="iSpeakWellCookieName"
                    style={{ background: "#2B373B" }}
                    buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                    expires={150}
                  >
                    This website uses cookies to enhance the user experience.
                  </CookieConsent>
                </div>
                <TokenProvider>
                  <ScrollToTop />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/jobbank" element={<JobBankLandingPage />} />
                    <Route path="/cookie-policy" element={<CookiePolicy />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/signup"
                      element={signupEnabled ? <Signup /> : <Signdown />}
                    />
                    <Route path="/about" element={<About />} />
                    <Route path="/tokens" element={<Tokens />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/contactus" element={<Contactus />} />
                    <Route path="/accountdeleted" element={<AccountDeleted />} />
                    <Route path="/password-reset" element={<PasswordReset />} />
                    <Route path="/security" element={<Security />} />
                    <Route
                      path="/jobbank/about"
                      element={<JobBankAbout />}
                    />

                    <Route
                      path="/jobbank/contact"
                      element={<JobBankContact />}
                    />

                    <Route
                      path="/jobbank/help"
                      element={<JobBankHelp />}
                    />

                    <Route
                      path="/jobbank/login"
                      element={<JobBankLogin />}
                    />
                    <Route
                      path="/JobBankJobs"
                      element={
                              <JobBank />
                      }
                    />
                    <Route
                      path="/jobbank/signup"
                      element={signupEnabled ? <JobBankSignup /> : <JobBankSigndown  />}
                    />
                    <Route
                      path="/jobbank/password-reset"
                      element={<JobBankPasswordReset />}
                    />
                    <Route path="*" element={<NotFound />} />
                    <Route
                      path="/menu"
                      element={
                        <ProtectedRoute>
                          <Menu />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/voicebot"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <Suspense fallback={<Spinner />}>
                                {isMobile ? <VBM /> : <VB />}
                              </Suspense>
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/PodcastTools"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PodcastTools/>
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                  
                    <Route
                      path="/cecp"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <CareerCoachPortal />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/events"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <HiringEventsPortal />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/urlshortener"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <UrlShortenerAdmin />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/accessRequest"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <AccessRequest />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/accessRequests"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <AccessRequests />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/jobcarveouts"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <JobCarveOutPortal />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />

                    <Route 
                      path="/careercoaches" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PublicCareerCoachDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/careercoaches/:uid" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PublicCareerCoachDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/employers" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PublicEmployerDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/employers/:uid" 
                      element={
                        <ProtectedRoute>
                            <TimerProvider>
                            <VisemeProvider>
                              <PublicEmployerDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />

                    <Route 
                      path="/candidates" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PublicCandidateDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/candidates/:uid" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <PublicCandidateDirectory />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />

                    <Route 
                      path="/accessRequest" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <AccessRequest />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    /> 
                    <Route 
                      path="/accessRequests" 
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <AccessRequests />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      } 
                    />

                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <CandidateProfile />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/employer"
                      element={
                        <ProtectedRoute>
                          <TimerProvider>
                            <VisemeProvider>
                              <EmployerDashboard />
                            </VisemeProvider>
                          </TimerProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/termsofservice"
                      element={
                        <ProtectedRoute>
                          <TermsofService />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/privacypolicy"
                      element={
                        <ProtectedRoute>
                          <PrivacyPolicy />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/purchase"
                      element={
                        <ProtectedRoute>
                          <Purchase />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/pageexpired"
                      element={
                        <ProtectedRoute>
                          <PageExpired />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/paymentsuccessful"
                      element={
                        <ProtectedRoute>
                          <PaymentSuccessful />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/paymentnotsuccessful"
                      element={
                        <ProtectedRoute>
                          <PaymentNotSuccessful />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/purchasehistory" 
                      element={
                        <ProtectedRoute>
                          <PurchaseHistory />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/resumerevisor"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/interview-practice"
                      element={
                        <ProtectedRoute>
                          <VisemeProvider>
                            <InterviewPractice />
                          </VisemeProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/conversationpractice"
                      element={
                        <ProtectedRoute>
                          <VisemeProvider>
                            <ConversationPractice />
                          </VisemeProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute>
                          <Admin />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/offers"
                      element={
                        <ProtectedRoute>
                          <AdminOffersConsole />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </TokenProvider>
              </div>
            </PageTrackingWrapper>
          </Router>
        </VoiceBotStateProvider>
  );
};

export default App;
